// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Descriptive properties of a module
 */
export interface ModuleMetadataOutput {
  description?: unknown;
  objectives?: unknown;
  levels?: unknown;
  learningHours?: unknown;
  language?: unknown;
  ects?: unknown;
}
